// default
export const RISK_ASSESSMENT_STATUS = 'riskAssessmentStatus';
export const RISK_ASSESSMENT_STATUS_SLICE_NAME = `${RISK_ASSESSMENT_STATUS}Slice`;

// action
const GET_RISK_ASSESSMENT_STATUS = `${RISK_ASSESSMENT_STATUS}/GET_RISK_ASSESSMENT_STATUS`;
// actions
export const RasActions = {
  GET_RISK_ASSESSMENT_STATUS
};
